import { render } from "./MyAgentPanel.vue?vue&type=template&id=5d242934"
import script from "./MyAgentPanel.vue?vue&type=script&lang=js"
export * from "./MyAgentPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__